/** @jsx jsx */
// TODO: remove eslint statement when 'css' is implemented
import { jsx } from '@emotion/react';
// eslint-disable-next-line no-unused-vars
import React, { useCallback, useContext, useState } from 'react';
//import { MultiPropertySelector } from 'components/selectors/multiPropertySelector';
import { filterProperties } from 'utilities/srsUtils';
import { WorkspaceContext } from 'views/workspace/workspaceContext';
import { WorkspaceActionCreator } from 'hooks/useWorkspaceState';
import { Checkbox, H6, Tab, Tabs } from '@blueprintjs/core';
import { DILProperty } from 'srs-middleware';
import { GenericObject } from 'interfaces/GenericObject';
import debounce from 'lodash-es/debounce';

/**
 * Custom renderer for the controls available to change the chart settings.
 *
 * Data Properties for this Widget:
 *   -- propertyList
 *   -- limit
 *
 * Chart Properties for this Widget:
 *
 * @param chartConfiguration
 * @param updateConfiguration
 * @returns {*}
 * @constructor
 */
export const TypographWidgetKnobs = ({
                                       cardIndex,
                                       endpointQuery,
                                       types
                                     }) => {
	const {
		state: {
			explorer: { selectedDefinitionName },
		},
		dispatch,
	} = useContext(WorkspaceContext);
	const propertyName = 'propertyList';

	const selectedColumnNames = endpointQuery?.options?.[propertyName];
	const [filteredProperties, updateProperties] =
		useState<GenericObject<boolean>>(
			filterProperties(selectedDefinitionName, [], types)
				.reduce((coll: GenericObject<boolean>, property: DILProperty) =>
						(coll[property.name] = selectedColumnNames.includes(property.name), coll),
					{})
		);

	const _updateServer = useCallback(debounce((newSelectedColumns) => {
		// create copy of options object
		const newEndpointQuery = JSON.parse(JSON.stringify(endpointQuery));
		newEndpointQuery.options[propertyName] =
			Object.entries(newSelectedColumns)
				.filter(([,v]) => v)
				.map(([k]) => k);
		dispatch(WorkspaceActionCreator.options(cardIndex, newEndpointQuery));
	}, 700),[]);

	const _updateOption = (property: string, value: boolean=!filteredProperties[property]) => {
		const newSelectedColumns = {...filteredProperties, [property]: value};
		if (Object.values(newSelectedColumns).filter((value) => value === true).length >= 1) {
			updateProperties(newSelectedColumns);
			_updateServer(newSelectedColumns);
		} else {
			console.warn('Trying to unselect all properties...preventing action')
		}
	};

	return (
		<Tabs>
			<Tab id="data" title="Data" panel={
				<React.Fragment>
					<H6>Select Properties</H6>
					{
						Object.entries(filteredProperties).map(([k,v]) =>
							<Option key={k} entry={k} value={v} update={_updateOption}/>
						)
					}
				</React.Fragment>
			}/>
		</Tabs>
  );
};


function Option({entry, value, update}: {entry: string, value: boolean, update: (arg: string) => void}) {
	const _onChange = () => update(entry)

	return <Checkbox checked={value}
					label={entry}
					onChange={_onChange}
	/>
}
